module.exports = __webpack_public_path__ + "static/media/correctivostickets-06-rojo.069b430c.svg";